import { Col } from 'reactstrap';

import { Row } from 'reactstrap';
import { SectionTitle } from '../../../../../components/text';
import StudentCurriculumProgress from '../../../../CurriculumProgressStudent/parts/StudentCurriculumProgress';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { StudyPlanEnrollmentsInfo } from '../../../../StudentManagement/StudentFile/types';

interface CurriculumInfoProps {
  studyPlanEnrollmentId: string | undefined;
  studyPlanEnrollmentsInfo: StudyPlanEnrollmentsInfo[];
}

export default function CurriculumInfo({
  studyPlanEnrollmentId,
  studyPlanEnrollmentsInfo,
}: CurriculumInfoProps) {
  const { t } = useTranslation();
  const tabsPrefix = 'studentManagement.academicHistory';

  const curricularProgress = useMemo(() => {
    return studyPlanEnrollmentsInfo.find(
      (studyPlanEnrollment) =>
        studyPlanEnrollment.studyPlanEnrollmentId ===
        Number(studyPlanEnrollmentId),
    );
  }, [studyPlanEnrollmentId, studyPlanEnrollmentsInfo]);

  return (
    <Col className="mt-2">
      <Row>
        <SectionTitle text={t(`${tabsPrefix}.title`)} />
        <p className="text-medium fs-16 mt-3 mb-4">
          {t(`${tabsPrefix}.description`)}
        </p>
      </Row>
      <Row>
        <StudentCurriculumProgress
          studyPlanEnrollmentId={Number(studyPlanEnrollmentId)}
          curriculumProgressAvg={curricularProgress?.progressAverage ?? null}
          texts={{
            CurriculumProgressTooltip: t(
              `curriculumProgressStudent.curriculumProgressTooltip`,
            ),
            CurriculumProgress: t(
              `curriculumProgressStudent.curriculumProgress`,
            ),
          }}
        />
      </Row>
    </Col>
  );
}
